/* eslint-disable no-param-reassign */
import axios from 'axios';
import * as R from 'ramda';

import { handleApikoHttpResponse } from '../../redux/utils';

export const apiServer = process.env.REACT_APP_API_URL || 'http://localhost:3000';

const apiBaseUrl = `${apiServer}/api`;

export const apikoApi = axios.create({
  baseURL: apiBaseUrl,
});

apikoApi.interceptors.request.use((config) => {
  // to avoid overwriting if another interceptor
  // already defined the same object (meta)
  config.meta = config.meta || {};
  config.meta.requestStartedAt = new Date().getTime();
  return config;
});

apikoApi.interceptors.response.use((config) => {
  config.responseTime = new Date().getTime() - config.config.meta.requestStartedAt;
  return config;
});

/**
 * authRequest :: AxiosConfig -> Promise Error AxiosResponse
 * AxiosConfig = Object
 * AxiosResponse = Object
 */
export const authRequest = (config) => {
  const token = localStorage.getItem('token');

  const withAuthTokenConfig = R.mergeDeepLeft(
    config,
    { headers: { Authorization: `Bearer ${token}` } },
  );

  return apikoApi(withAuthTokenConfig)
    .then((data) => {
      handleApikoHttpResponse();
      return data;
    })
    .catch((error) => {
      handleApikoHttpResponse(error);
      return Promise.reject(error);
    });
};



// WEBPACK FOOTER //
// ./src/api/apiko-api/utils.js